'use strict';

// ⚠ .cjs 는 webpack 이 babel 없이 직접 파싱한다 → `??` / `?.` 금지 (production 빌드가 깨진다). 기존 .cjs 헬퍼들과 같은 제약.
//
// jsPDF 2.5.2 에서 탭 같은 제어문자가 들어가면 그 뒤 문장이 에러 없이 통째로 사라진다.
//   doc.text 는 그리기 전에 폰트에 없는 글자를 걸러내는데(jspdf.es.js:25092-25097) 코드 <256 은 예외로 통과시키고,
//   통과한 글자가 pdfEscape16 의 느슨한 비교(:24856, 숫자 0 == 문자열 "0")에 걸려 거기서 문자열을 끊는다.
//   코드 ≥256 인 없는 글자(이모지 등)는 그 글자만 빠지고 뒤는 안전하다 — 문제는 0~255 구간뿐.
// NotoSansKR·NotoSansSC 모두 0~255 중 없는 글자는 정확히 제어문자 65개(U+0000~001F, U+007F~009F)다 (실측).
// 엑셀·워드에서 붙여넣은 답변의 탭이 대표적 — 입력창엔 띄어쓰기로 보여 아무도 알아채지 못한다.
//
// 그리기 직전에 제어문자를 공백으로 바꾼다. \n·\r 은 jsPDF 가 줄 구분에 쓰므로 남긴다.
// 제어문자를 잡는 것이 이 정규식의 목적이라 no-control-regex 를 끈다 (ESLint 6 은 "-- 사유" 문법 미지원).
// eslint-disable-next-line no-control-regex
const CONTROL_CHARS = /[\u0000-\u0009\u000B\u000C\u000E-\u001F\u007F-\u009F]/g;

function safeText (text) {
    if (typeof text === 'string') return text.replace(CONTROL_CHARS, ' ');
    // splitTextToSize 가 돌려준 줄 배열도 그대로 doc.text 로 들어온다.
    if (Array.isArray(text)) return text.map(safeText);
    return text;
}

// 문서 인스턴스의 text 를 감싼다. autoTable 도 셀을 doc.text 로 그리므로 함께 걸린다.
// 인스턴스 단위라 이 문서에만 영향이 있고 jsPDF 전역(jsPDF.API)은 건드리지 않는다.
function installSafeText (doc) {
    const original = doc.text;
    doc.text = function (text) {
        const args = Array.prototype.slice.call(arguments);
        args[0] = safeText(text);
        return original.apply(this, args);
    };
    return doc;
}

module.exports = {
    safeText: safeText,
    installSafeText: installSafeText,
};
